import React from 'react';

const NotFound = () => {
	return (
		<div className='emptyPage'>404 Page not found.</div>
	);
};

export default NotFound;
